import { Container } from "@mui/material";
import { useContext, useEffect } from "react";
import { fixSiteState } from "../util/site_state";
import { SiteStateContext } from "../contexts/SiteStateContext";
import EditIcon from "@mui/icons-material/Edit";
import MarkdownRender from "../components/MarkdownRender";
import PageBlocksRenderer from "../components/PageBlocksRenderer";
import SEO from "../components/SEO";

interface Props {
    title: string;
    navHighlight: string;
    markdown: string;
    blocks?: string;
    seoTitle?: string;
    seoDescription?: string;
    seoKeywords?: string;
    seoImage?: string;
}

const PageRenderer = ({ title, navHighlight, markdown, blocks, seoTitle, seoDescription, seoKeywords, seoImage }: Props) => {
    const { setSiteState } = useContext(SiteStateContext);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(
                fixSiteState({
                    title: title,
                    navHighlight: navHighlight,
                    actions: [
                        {
                            text: "Edit",
                            icon: EditIcon,
                            onClick: () => {
                                console.log("Edit");
                            },
                        },
                    ],
                })
            );
        }
    }, [setSiteState, title, navHighlight]);

    // Parse blocks if available
    let parsedBlocks: PageBlock[] = [];
    if (blocks) {
        try {
            parsedBlocks = JSON.parse(blocks);
        } catch (e) {
            console.error("Failed to parse blocks:", e);
        }
    }

    return (
        <Container sx={{ mt: 3 }}>
            <SEO
                title={seoTitle || `${title} - River Hawk Chapter`}
                description={seoDescription}
                keywords={seoKeywords}
                image={seoImage}
            />
            {parsedBlocks.length > 0 ? (
                <PageBlocksRenderer blocks={parsedBlocks} />
            ) : (
                <MarkdownRender markdown={markdown} />
            )}
        </Container>
    );
};

export default PageRenderer;
